import React, { useState } from 'react';
import { X } from "lucide-react"
import { Lock } from "lucide-react"

interface ModalProps {
  title: string;
  content: React.ReactNode;
  close: (value: boolean) => void;
  buttonText: string;
  noLines?: boolean;
  onButtonClick?: () => void;
  icon?: React.ReactNode; // Optional custom icon
  checkbox?: {
    text: React.ReactNode;
    onChange: (checked: boolean) => void;
    checked: boolean;
    description?: string;
  };
  disableButtonWhenUnchecked?: boolean;
}

//generic modal
export const Modal = ({ 
  title, 
  content, 
  close, 
  buttonText, 
  noLines = false, 
  onButtonClick,
  icon,
  checkbox,
  disableButtonWhenUnchecked = false
}: ModalProps) => {

    // Use the provided onButtonClick handler or default to close
    const handleButtonClick = () => {
      if (onButtonClick) {
        onButtonClick();
      } else {
        close(false);
      }
    };

    const isButtonDisabled = disableButtonWhenUnchecked && checkbox && !checkbox.checked;

    return (
      <div className="account-modal">
        <div className="account-modal__container" >
          <div className={`account-modal__header ${noLines ? 'account-modal__header--no-lines' : ''}`}>
            <div className="account-modal__title-container">
              {icon ? icon : (title ? <Lock size={24} className="me-2" /> : null)}
              {title && <h2 className="account-modal__title">{title}</h2>}
            </div>
            <button className="account-modal__close" onClick={() => close(false)} aria-label="Close modal">
              <X size={20} />
            </button>
          </div>
  
          <div className="account-modal__content" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
            {content}
            
            {checkbox && (
              <div className="account-modal__checkbox-container">
                <label className="account-modal__checkbox-label">
                  <input 
                    type="checkbox" 
                    checked={checkbox.checked} 
                    onChange={(e) => checkbox.onChange(e.target.checked)}
                  />
                  <span>{checkbox.text}</span>
                </label>
                {checkbox.description && (
                  <div className="account-modal__checkbox-description">
                    {checkbox.description}
                  </div>
                )}
              </div>
            )}
          </div>

          <div className={`account-modal__footer ${noLines ? 'account-modal__footer--no-lines' : ''}`}>
            <button 
              className="account-modal__save" 
              onClick={handleButtonClick} 
              aria-label={buttonText}
              disabled={isButtonDisabled}
              style={isButtonDisabled ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
            >
              {buttonText}
            </button>
          </div>

        </div>
      </div>
    )
  }